import React from 'react'
import { SelectedTrustBadge } from 'src/lib/types/merchantAttributes'

interface PreviewBadgesrops {
  badges: SelectedTrustBadge[]
  showBadges: boolean
}

const PreviewBadges: React.FC<PreviewBadgesrops> = ({ badges, showBadges }) => {
  if (!Boolean(showBadges) || !Boolean(badges?.length)) return <></>

  const filteredBadges = badges.filter((badge: SelectedTrustBadge) => badge?.isActive)

  return (
    <div className='flex justify-center gap-2 mx-4'>
      {filteredBadges?.map((badge: SelectedTrustBadge) => {
        return (
          <div className='flex flex-col items-center w-16 gap-[2px]' key={badge?.label}>
            <div className='flex items-center justify-center '>
              <img src={badge?.imgPath} alt={badge?.label} className='w-5 h-5' />
            </div>
            <div className='w-full flex items-center justify-center text-[10px] text-center text-gray-dark'>
              {badge?.text}
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default PreviewBadges
